module.exports = __webpack_public_path__ + "static/img/menu_2.450b8c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_2.png
// module id = at4z
// module chunks = 1